<template>
    <iframe
      v-bind="$attrs"
      v-if="!fake"
      :src="src"
      @load="load($event)"
      :class="!addClasses ? '' : 'min-h-[70vh] w-full'"
    />
</template>
<script>
import { IS_LOCALHOST } from '@/config/constants';

export default {
  inheritAttrs: false,
  props: {
    src: {
      type: String,
      required: true,
    },
    addClasses: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      fake: window.Cypress !== undefined || IS_LOCALHOST,
    };
  },
  created() {
    if (this.fake) {
      this.load();
    }
  },
  methods: {
    load($event) {
      this.$emit('load', $event);
    },
  },
};
</script>
